{
  "zh-CN": {
    "models": {
      "name": "飞船",
      "model": {
        "metrics": {
          "base": "基础",
          "crew": "船员",
          "info": "信息",
          "levels": "等级",
          "speed": "速度"
        },
        "focus": "定位",
        "classification": "分类",
        "size": "尺寸",
        "beam": "宽度",
        "cargo": "货物",
        "netCargo": "含 Rover/Snub 的货物",
        "crew": "船员",
        "speed": "速度",
        "minCrew": "最少船员",
        "maxCrew": "最多船员",
        "scmSpeed": "SCM Speed",
        "maxSpeed": "最大速度",
        "scm": "SCM",
        "max": "最大",
        "groundMaxSpeed": "最大速度",
        "groundReverseSpeed": "倒退速度",
        "pitch": "Pitch",
        "yaw": "Yaw",
        "roll": "Roll",
        "price": "价格",
        "groundAcceleration": "加速",
        "groundDecceleration": "减速",
        "scmSpeedAcceleration": "零到 SCM",
        "scmSpeedDecceleration": "SCM 到零",
        "maxSpeedAcceleration": "零到最大",
        "maxSpeedDecceleration": "最大到零",
        "compare": {
          "groundMaxSpeed": "最大地面速度",
          "groundReverseSpeed": "地面倒退速度",
          "groundAcceleration": "地面加速",
          "groundDecceleration": "地面减速"
        },
        "quantumFuelTankSize": "量子燃料",
        "hydrogenFuelTankSize": "燃料",
        "pledgePrice": "质押价格",
        "height": "高度",
        "length": "长度",
        "mass": "质量",
        "manufacturer": "制造商",
        "hardpoints": "挂载点",
        "weapons": "武器",
        "equipment": "装备",
        "variants": "变体",
        "maxUpgrades": "升级",
        "productionStatus": "生产状态",
        "propulsion": "推进",
        "ordnance": "武器弹药",
        "modular": "模块化",
        "soldAt": "在哪里出售?",
        "rentalAt": "在哪里租赁?",
        "lastUpdatedAt": "最后更新时间?",
        "loaners": "借用船",
        "paints": "涂装",
        "modules": "模块",
        "modulePackages": "模块包",
        "upgrades": "升级套件",
        "brochure": "手册",
        "onSale": "在售",
        "salesPage": "销售页面",
        "addons": "模块与升级套件",
        "productionStatuses": {
          "notAvailable": "N/A",
          "in-production": "生产中",
          "in-concept": "概念阶段",
          "ready": "机库就绪",
          "flight-ready": "可飞行",
          "announced": "已公布"
        }
      }
    }
  }
}
